export const GET_AREAFENCE_DATA = "GET_AREAFENCE_DATA";
export const ADD_AREAFENCE = "ADD_AREAFENCE";
export const UPDATE_AREAFENCE = "UPDATE_AREAFENCE";
export const GET_SOS_CATEGORIES = "GET_SOS_CATEGORIES";
export const UPDATE_SOS_CATEGORIES_STATUS = "UPDATE_SOS_CATEGORIES_STATUS";
export const ADD_SOS_CATEGORY = "ADD_SOS_CATEGORY";
export const UPDATE_SOS_CATEGORY = "UPDATE_SOS_CATEGORY";
export const GET_SOS_PROVIDERS = "GET_SOS_PROVIDERS";
export const GET_SOS_CATEGORIES_DROPDOWN = "GET_SOS_CATEGORIES_DROPDOWN";
export const GET_SOS_ZONES_DROPDOWN = "GET_SOS_ZONES_DROPDOWN";
export const UPDATE_SOS_PROVIDERS_STATUS = "UPDATE_SOS_PROVIDERS_STATUS";
export const ADD_SOS_PROVIDER = "ADD_SOS_PROVIDER";
export const UPDATE_SOS_PROVIDER = "UPDATE_SOS_PROVIDER";
export const GET_SOS_ZONES = "GET_SOS_ZONES";
export const UPDATE_SOS_ZONES_STATUS = "UPDATE_SOS_ZONES_STATUS";
export const ADD_SOS_ZONE = "ADD_SOS_ZONE";
export const UPDATE_SOS_ZONE = "UPDATE_SOS_ZONE";
export const GET_SOS_MEMBERS = "GET_SOS_MEMBERS";
export const UPDATE_SOS_MEMBER_STATUS = "UPDATE_SOS_MEMBER_STATUS";
export const ADD_SOS_MEMBER = "ADD_SOS_MEMBER";
export const UPDATE_SOS_MEMBER = "UPDATE_SOS_MEMBER";
export const GET_SOS_PROVIDERS_DROPDOWN = "GET_SOS_PROVIDERS_DROPDOWN";
export const GET_CIRCULARFENCE_DATA = "GET_CIRCULARFENCE_DATA";
export const ADD_CIRCULARFENCE = "ADD_CIRCULARFENCE";
export const UPDATE_CIRCULARFENCE = "UPDATE_CIRCULARFENCE";
export const GET_ROUTEFENCE_DATA = "GET_ROUTEFENCE_DATA";
export const ADD_ROUTEFENCE = "ADD_ROUTEFENCE";
export const GET_GEOFENCE_DEVICES = "GET_GEOFENCE_DEVICES";
export const UPDATE_GEOFENCE_DEVICE_STATUS = "UPDATE_GEOFENCE_DEVICE_STATUS";
export const ADD_GEOFENCE_DEVICE = "ADD_GEOFENCE_DEVICE";
